import React from 'react';

import clsx from 'clsx';

import styles from './InfoIcon.module.scss';

export interface InfoIconProps {
  iconClassName?: string;
}
const InfoIcon = ({ iconClassName }: InfoIconProps) => {
  return <div className={clsx(styles.icon, iconClassName)}>i</div>;
};

export default InfoIcon;
